<template>
    <q-list bordered class="rounded-borders">
        <q-expansion-item
            v-model="expanded"
            expand-separator
            :label="filterName"
            header-class='text-primary'
            expand-icon-class='text-primary'
            color='primary'
        >
            <q-separator inset color='primary' style='margin-bottom:12px;'/>
            <slot></slot>
        </q-expansion-item>
    </q-list>
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue'

const expanded = ref(false)
const props = defineProps({
    filterName: {
        type: String,
        default: 'Filter Name'
    },
    expand: {
        type: Boolean,
        default: false
    }
})

onMounted(() => {
    expanded.value = props.expand
})

</script>

<style lang='scss' scoped>

</style>